import React  from 'react';
import { Link } from 'react-router-dom';

function Footer (props) {
    const linkedInURL = "https://nz.linkedin.com/company/siso-solutions";

    return (
        <div id="footer" className="row">
            <div className="col-md-4 col-sm-5 col-5" id="footerLeft">
                <div id="contact_linkedin">
                    <Link to={linkedInURL} reloadDocument className="footerLink" id="footer_linkedin" >
                        <svg version="1.1" className="footer_svg" id="linkedin_svg" role="img" aria-labelledby="lITitle lIDesc" x="0px" y="0px"
                            width="96px" height="80px" viewBox="0 0 96 80" preserveAspectRatio="xMidYMid">
                            <title id="lITitle">LinkedIn Logo</title>
                            <desc id="lIDesc">Link to visit the Siso LinkedIn page</desc>
                            <path fill="none" stroke="#010202" strokeWidth="2" strokeMiterlimit="10" d="M25.727,11.442c0,4.382-3.523,7.933-7.87,7.933
	c-4.348,0-7.871-3.551-7.871-7.933c0-4.378,3.523-7.933,7.871-7.933C22.203,3.51,25.727,7.064,25.727,11.442z M25.789,25.721H9.924
	v50.769h15.865V25.721z M51.117,25.721H35.352v50.769h15.766V49.841c0-14.817,19.131-16.032,19.131,0v26.648h15.828V44.344
	c0-25.003-28.31-24.095-34.959-11.784V25.721z"/>
                        </svg>
                    </Link>
                </div>
            </div>
            <div className="col-md-4 col-sm-2 col-2" id="footerMiddle">
            
            </div>
            <div className="col-md-4 col-sm-5 col-5" id="footerRight">
			    <div className="row">
				    <div id ="logoPNG" >
			            <svg version="1.1" id="logoFooter" role="img" aria-labelledby="logoFooterTitle logoFooterDesc" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
		 	                width="200px" height="470px" viewBox="0 0 200 470" enableBackground="new 0 0 200 470" preserveAspectRatio="xMidYMin">
			                <title id = "logoFooterTitle">Siso Logo</title>
			                <desc id = "logoFooterDesc">UX, Mobile and Web</desc>
				            <g>
					            <path id="logo_path_1" fill="#EF4939" d="M100,145c-49.706,0-90,40.294-90,90s40.294,90,90,90s90-40.294,90-90S149.706,145,100,145z M100,280
					            c-24.853,0-45-20.147-45-45s20.147-45,45-45s45,20.147,45,45S124.853,280,100,280z"/>
					            <path id="logo_path_2" fill="#EF4939" d="M100,280v45c24.853,0,45,20.146,45,45c0,24.854-20.147,45-45,45s-45-20.146-45-45
					            c0-15.954,8.309-29.958,20.829-37.948c-16.044-3.983-30.556-11.838-42.49-22.519C18.837,325.511,10,346.723,10,370
					            c0,49.706,40.294,90,90,90s90-40.294,90-90C190,320.294,149.706,280,100,280z"/>
					            <path id="logo_path_3" fill="#EF4939" d="M100,145c-24.853,0-45-20.146-45-45c0-24.853,20.147-45,45-45s45,20.146,45,45
					            c0,15.954-8.31,29.958-20.829,37.948c16.044,3.983,30.556,11.838,42.49,22.519C181.163,144.49,190,123.277,190,100
					            c0-49.706-40.294-90-90-90s-90,40.294-90,90c0,49.706,40.294,90,90,90V145z"/>
				            </g>
			            </svg>
	                </div>
		        </div>
		        <div className="row">
			        <div id="copyright">
		                <p>&copy; 2025. <span>SISO SOLUTIONS LTD</span></p>
		            </div>
                </div>
	        </div>
        </div>
    );
}

export default Footer;